export const CASINO_CONFIG = {
  errorImageUrl: 'images/shared/default-casino.png',
  defaultImageUrl: 'images/shared/default-casino.png',
  providerAll: {
    ProviderId: 0,
    ProviderName: 'all',
  },
  categoriesAll: {
    CategoryName: 'all',
    CategoryId: 0,
  },
  startingCategoryId: 0,
  startingProviderId: 0,
  gameStartingPage: 1,
  gameLimit: 30,
  favGameStartingPage: 1,
  favGameLimit: 30,
  startingProviderMenuState: false,
  searchInputDebounceMillisecond: 300,
  mobileVersionWidth: 990,
} as const;
